@if (visible) {
  <div class="export-save-dialog__backdrop" (click)="cancel()"></div>
  <div
    class="export-save-dialog__card"
    role="dialog"
    aria-modal="true"
    aria-labelledby="export-save-dialog-title"
  >
    <div class="export-save-dialog__modal-head">
      <div
        id="export-save-dialog-title"
        class="export-save-dialog__modal-title"
      >
        {{ 'consultant.export.modal.title' | translate }}
      </div>
      <button
        class="export-save-dialog__modal-x"
        type="button"
        [attr.aria-label]="'general.close' | translate"
        (click)="cancel()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="export-save-dialog__modal-body">
      <label
        class="export-save-dialog__field-label"
        for="export-save-dialog-name"
        >{{ 'consultant.export.modal.nameLabel' | translate }}</label
      >
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        class="export-save-dialog__name-field"
      >
        <input
          matInput
          id="export-save-dialog-name"
          [value]="name"
          [attr.maxlength]="maxLength ?? null"
          [placeholder]="'consultant.export.modal.namePlaceholder' | translate"
          (input)="onNameInput($event)"
        />
      </mat-form-field>
    </div>

    <div class="export-save-dialog__modal-foot">
      <div class="export-save-dialog__modal-actions">
        <button
          type="button"
          class="export-save-dialog__btn-text export-save-dialog__cancel"
          (click)="cancel()"
        >
          {{ 'general.cancel' | translate }}
        </button>
        <button
          type="button"
          class="export-save-dialog__btn-text export-save-dialog__without-saving"
          (click)="exportWithoutSaving.emit()"
        >
          {{ 'consultant.export.modal.exportWithoutSaving' | translate }}
        </button>
        <button
          type="button"
          class="export-save-dialog__btn-primary export-save-dialog__save"
          [disabled]="!canSave"
          (click)="save()"
        >
          {{ 'consultant.export.modal.saveAndExport' | translate }}
        </button>
      </div>
    </div>
  </div>
}
